import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import cloudflareIcon from '../../Assets/images/cloudflare_logo_icon_512x512.png';
import { TurnstileLink } from '../../Configs/Links';
import { TURNSTILE_WIDGET_DIMENSIONS_BY_SIZE } from './TurnstileManagedCaptcha';

const TurnstileSuccessMock = ({ style, heightScale, size }) => {
  const classes = useStyles();
  const scale = heightScale || 1;
  const { height: baseHeight } =
    TURNSTILE_WIDGET_DIMENSIONS_BY_SIZE[size] ||
    TURNSTILE_WIDGET_DIMENSIONS_BY_SIZE.normal;
  const wrapperStyle = {
    position: 'relative',
    height: Math.ceil(baseHeight * scale),
    overflow: 'hidden',
    clipPath: 'inset(0)',
    marginTop: 14,
    ...style
  };
  const innerStyle =
    scale === 1
      ? undefined
      : { transform: `scaleY(${scale})`, transformOrigin: 'left top' };

  return (
    <div style={wrapperStyle}>
      <div className={classes.root} style={innerStyle}>
        <div className={classes.left}>
          <CheckCircleIcon className={classes.icon} />
          <Typography className={classes.successText}>
            ¡Operación exitosa!
          </Typography>
        </div>
        <div className={classes.right}>
          <div className={classes.brandWrapper}>
            <img
              src={cloudflareIcon}
              alt="Cloudflare"
              className={classes.brandIcon}
            />
            <Typography className={classes.brand}>CLOUDFLARE</Typography>
          </div>
          <Typography className={classes.links}>
            <a
              href={TurnstileLink.PrivacyPolicy}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Privacidad
            </a>
            {' · '}
            <a
              href={TurnstileLink.Help}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.link}
            >
              Ayuda
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    backgroundColor: '#f8f8f8',
    padding: '0 12px',
    height: 65,
    width: '100%',
    boxSizing: 'border-box'
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  icon: {
    color: '#008a30',
    fontSize: 26
  },
  successText: {
    fontSize: 11,
    color: '#333',
    fontWeight: 600
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    alignSelf: 'stretch',
    paddingTop: 6,
    paddingBottom: 10
  },
  brandWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 0
  },
  brandIcon: {
    width: 32,
    height: 32,
    objectFit: 'contain',
    marginBottom: -5
  },
  brand: {
    fontSize: 10,
    fontWeight: 700,
    color: '#000',
    letterSpacing: 0.5,
    lineHeight: 1
  },
  links: {
    fontSize: 8,
    color: '#000'
  },
  link: {
    textDecoration: 'underline',
    color: 'inherit'
  }
});

export default TurnstileSuccessMock;
